/**
 * Ikony ekranow treningu, ktorych nie ma jeszcze w components/icons/ (tego pliku ten widok nie edytuje).
 *
 * IC-1: styl liniowy, kreska 2px w skali 24, `currentColor`. Sciezka "Wyslij" 1:1 z snippets/chat.html. Gdy ikona trafi do
 * components/icons/, ten plik mozna usunac.
 */

/** Wyslanie odpowiedzi w rozmowie (papierowy samolocik z chat.html). */
export function IkonaWyslij({ size = 18 }: { size?: number }): React.JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M22 2 11 13M22 2l-7 20-4-9-9-4 20-7z" />
    </svg>
  );
}
